import { render, staticRenderFns } from "./ResumenCard.vue?vue&type=template&id=ba7193ca&scoped=true&"
import script from "./ResumenCard.vue?vue&type=script&lang=ts&"
export * from "./ResumenCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResumenCard.vue?vue&type=style&index=0&id=ba7193ca&lang=scss&scoped=true&"
import style1 from "./ResumenCard.vue?vue&type=style&index=1&id=ba7193ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7193ca",
  null
  
)

export default component.exports